import type { MenuItem } from "@/entity/mytask/recentNews";

// value为后端定义的模块枚举值（\meta\mytask\recentNews.ts），但只有最内层的value是真实枚举
export const moduleData: MenuItem[] = [
    {
        value: 100,
        label: "用户管理",
        children: [
            {
                value: 101,
                label: "链云用户管理",
                children: [
                    { value: 1, label: "链云用户" },
                    { value: 58, label: "组织机构管理" }
                ]
            },
            {
                value: 102,
                label: "会员管理",
                children: [
                    { value: 2, label: "充值列表" },
                    { value: 3, label: "激活码" },
                    { value: 4, label: "推广管理" },
                    { value: 5, label: "会员等级" }
                ]
            },
            { value: 6, label: "定制管理" }
        ]
    },
    {
        value: 200,
        label: "指数管理",
        children: [
            {
                value: 201,
                label: "砂石指数",
                children: [
                    { value: 7, label: "砂石指数" },
                    { value: 8, label: "砂石综合指数" },
                    { value: 9, label: "砂石综合指数配置" },
                    { value: 56, label: "砂石指数版本提交记录" }
                ]
            },
            {
                value: 202,
                label: "运价指数",
                children: [
                    { value: 10, label: "运价指数" },
                    { value: 11, label: "运价综合指数" },
                    { value: 55, label: "运价综合指数配置" },
                    { value: 12, label: "运价指数版本提交记录" }
                ]
            },
            {
                value: 204,
                label: "油品指数",
                children: [
                    { value: 75, label: "油品指数" },
                    { value: 74, label: "油品指数版本提交记录" }
                ]
            },
            {
                value: 203,
                label: "资讯管理",
                children: [
                    { value: 13, label: "砂石资讯" },
                    { value: 57, label: "砂石学院" }
                ]
            },
            { value: 14, label: "航线管理" }
        ]
    },
    {
        value: 300,
        label: "交易管理",
        children: [
            { value: 15, label: "品类管理" },
            {
                value: 301,
                label: "商品管理",
                children: [
                    { value: 79, label: "寄售商品管理" },
                    { value: 80, label: "团购商品管理" },
                    { value: 81, label: "捡漏商品管理" }
                ]
            },
            { value: 85, label: "交易订单" },
            { value: 86, label: "申请寄样" },
            { value: 87, label: "退款管理" },
            { value: 88, label: "活动列表" },
            { value: 89, label: "收款管理" },
            { value: 82, label: "发票管理" },
            { value: 83, label: "供应商管理" },
            { value: 84, label: "资金线索" }
        ]
    },
    {
        value: 500,
        label: "物流管理",
        children: [
            { value: 20, label: "码头管理" },
            {
                value: 501,
                label: "设备管理",
                children: [
                    { value: 21, label: "设备管理" },
                    { value: 22, label: "设备申领" }
                ]
            },
            { value: 23, label: "船主线索" },
            {
                value: 502,
                label: "船舶管理",
                children: [
                    { value: 24, label: "船舶信息" },
                    { value: 25, label: "认证审核" }
                ]
            },
            {
                value: 503,
                label: "船运需求",
                children: [
                    { value: 27, label: "船运需求发布" },
                    { value: 28, label: "船运单" }
                ]
            },
            {
                value: 505,
                label: "加油管理",
                children: [
                    { value: 70, label: "站点管理" },
                    { value: 73, label: "油品订单" }
                ]
            },
            {
                value: 504,
                label: "监控",
                children: [
                    { value: 29, label: "监控预警" },
                    { value: 30, label: "模型数据列表" },
                    { value: 31, label: "识别记录列表" }
                ]
            },
            { value: 62, label: "用户反馈" }
        ]
    },
    {
        value: 600,
        label: "财税管理",
        children: [
            { value: 32, label: "平台银行账号" },
            {
                value: 602,
                label: "船务交易",
                children: [
                    { value: 35, label: "船运费用" },
                    { value: 36, label: "船务信息服务费" },
                    { value: 71, label: "油品费用" }
                ]
            }
        ]
    },
    {
        value: 700,
        label: "平台管理",
        children: [
            {
                value: 701,
                label: "组织用户",
                children: [
                    { value: 37, label: "组织架构" },
                    { value: 38, label: "后台用户" },
                    { value: 39, label: "角色管理" }
                ]
            },
            {
                value: 702,
                label: "广告管理",
                children: [
                    { value: 40, label: "小程序" },
                    { value: 41, label: "PC 端" },
                    { value: 42, label: "广告页列表" }
                ]
            },
            { value: 44, label: "配置管理" },
            {
                value: 703,
                label: "标签管理",
                children: [
                    { value: 43, label: "标签列表" },
                    { value: 60, label: "搜索发现" }
                ]
            },
            {
                value: 704,
                label: "留言管理",
                children: [{ value: 59, label: "留言反馈" }]
            },
            {
                value: 705,
                label: "关于链云",
                children: [
                    { value: 45, label: "关于我们" },
                    { value: 46, label: "用户协议" },
                    { value: 47, label: "隐私政策" },
                    { value: 48, label: "会员服务协议" },
                    { value: 49, label: "设备申领协议" },
                    { value: 76, label: "船运合同服务协议" },
                    { value: 72, label: "加油协议" },
                    { value: 61, label: "帮助中心" }
                ]
            },
            {
                value: 706,
                label: "应用管理",
                children: [
                    {
                        value: 64,
                        label: "应用管理"
                    },
                    {
                        value: 68,
                        label: "回调记录"
                    }
                ]
            },
            {
                value: 67,
                label: "APP版本管理"
            }
        ]
    },
    {
        value: 800,
        label: "智能助理",
        children: [
            {
                value: 801,
                label: "AI语料库",
                children: [
                    { value: 65, label: "AI语料发布" },
                    { value: 66, label: "AI语料库" }
                ]
            }
        ]
    }
];
